import React from 'react';
import { Flex, Box, Text, Image, Button } from 'rebass';
import styled from 'styled-components';
import { RECRUITER, EMPLOYER } from 'constants/index';
import plusIcon from 'assets/icons/plus.png';
import Link from 'components/Link';
import colors from 'theme/colors';
import { UserRoleType } from 'types/global';

const CreateLink = styled(Link)`
  display: flex;
  align-items: center;
`;

const NavButton = styled(Flex)<any>`
  #navButtonHover {
    visibility: ${props => props.active && 'visible'};
  }
`;
const NavButtonHover = styled(Box)`
  background: ${colors.turquoise};
  height: 10px;
  border-radius: 5px;
  visibility: hidden;
`;

interface JobPostsNavigationProps {
  userRole: UserRoleType;
  hasJobPosts: boolean;
  url: string;
}

const JobPostsNavigation: React.FC<JobPostsNavigationProps> = (props): JSX.Element => {
  const { userRole, hasJobPosts, url } = props;
  return (
    <>
      {userRole === EMPLOYER && (
        <Flex
          width="100%"
          justifyContent="space-between"
          alignItems="center"
          mb={hasJobPosts ? 5 : 0}
        >
          <Text fontSize="24px" fontWeight={5}>
            My Postings
          </Text>
          <CreateLink to="/create-job-post" color={colors.lightGreen} hover={colors.lightGreen}>
            <Image src={plusIcon} mr={1} />
            <Text fontSize="24px" fontWeight={6}>
              Create
            </Text>
          </CreateLink>
        </Flex>
      )}
      {userRole === RECRUITER && (
        <Flex width="100%" mb={hasJobPosts ? 5 : 0}>
          <Flex as="nav" width="100%" justifyContent="space-between" css="max-width: 280px;">
            <NavButton flexDirection="column" active={url === '/job-posts'}>
              <Link to="/job-posts">
                <Button variant="navigation">My Jobs</Button>
              </Link>
              <NavButtonHover id="navButtonHover" />
            </NavButton>
            <NavButton flexDirection="column" active={url === '/job-posts/all'}>
              <Link to="/job-posts/all">
                <Button variant="navigation">All Jobs</Button>
              </Link>
              <NavButtonHover id="navButtonHover" />
            </NavButton>
          </Flex>
        </Flex>
      )}
    </>
  );
};

export default JobPostsNavigation;
